import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SessionSignalService {

  // this is our "message channel"
  private signalSource = new Subject<boolean>();

  signal$ = this.signalSource.asObservable();

  emit401() {
    this.signalSource.next(true);
  }

  reset() {
    this.signalSource.next(false);
  }
}